import { render, staticRenderFns } from "./ShowGrMemM.vue?vue&type=template&id=286ebeca&scoped=true&"
import script from "./ShowGrMemM.vue?vue&type=script&lang=js&"
export * from "./ShowGrMemM.vue?vue&type=script&lang=js&"
import style0 from "./ShowGrMemM.vue?vue&type=style&index=0&id=286ebeca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ebeca",
  null
  
)

component.options.__file = "ShowGrMemM.vue"
export default component.exports